import { FC } from 'react'
import { Info, Server, ShieldCheck, ScrollText } from 'lucide-react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@wellesley/ui/components/ui/dropdown-menu'
import { AppsLink } from '@wellesley/router'
import { TitleBlock } from '../../../common/components/ToolbarItem/TitleBlock'

type TContentItem = {
  icon: JSX.Element
  text: string
}

const ContentItem: FC<TContentItem> = ({ icon, text }) => (
  <DropdownMenuItem className="flex cursor-pointer gap-xxs">
    {icon}
    <p>{text}</p>
  </DropdownMenuItem>
)

const iconProps = { size: 20, color: 'var(--gray-900)' }

export const ServerInfoDropdown: FC = () => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <TitleBlock
          id="server-info"
          Icon={Info}
          variant="square"
          tooltipText="Server info"
          isItemActive={false}
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start">
        <AppsLink to="/about">
          <ContentItem icon={<Server {...iconProps} />} text="About Server" />
        </AppsLink>
        <AppsLink to="/privacy">
          <ContentItem
            icon={<ShieldCheck {...iconProps} />}
            text="Privacy Policy"
          />
        </AppsLink>
        <AppsLink to="/terms">
          <ContentItem
            icon={<ScrollText {...iconProps} />}
            text="Terms of Use"
          />
        </AppsLink>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
